import { createSlice } from "@reduxjs/toolkit";
import { getAllDocumentsThunk, getDocumentByIdThunk, submitDocumentThunk, uploadDocumentThunk } from "../action/document.action";
import { documentInitialState, summaryInitialState } from "src/models/document/document.dto";


export const documentSlice = createSlice({
    name: 'document',
    initialState: documentInitialState,
    reducers: {
        resetDocumentState: (state) => {
            // Reset state to its initial value
            return documentInitialState;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(uploadDocumentThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(uploadDocumentThunk.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(uploadDocumentThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            });

        // Submit Document
        builder
            .addCase(submitDocumentThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(submitDocumentThunk.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(submitDocumentThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            });
        // Get All Document
        builder
            .addCase(getAllDocumentsThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(getAllDocumentsThunk.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.pagination = action.payload.pagination || { totalItems: 0, totalPages: 0, currentPage: 1, pageSize: 10 }; 
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(getAllDocumentsThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            });
       
        // Get Document By ID
        builder
            .addCase(getDocumentByIdThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(getDocumentByIdThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.data;
            })
            .addCase(getDocumentByIdThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            });
    }
});


export const { resetDocumentState } = documentSlice.actions;


export default documentSlice.reducer;
